import { Field } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    margin-top: 25px;
    display: flex;

    & > :not(:last-child) {
        margin-right: 20px;
    }
`;

export const FieldItem = styled(Field)`
    flex: 1;
    min-width: 100px;
`;

export const ContactFieldItem = styled(FieldItem)`
    flex: 3;
`;
